import {AiFillLinkedin} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://github.com/alexamankwah2', icon: <AiFillGithub/>},
    {id: 2, link: ' ', icon: <AiFillLinkedin/>},
    {id: 3, link: 'https://twitter.com', icon: <AiOutlineTwitter/>},
]

export default data